import { NgModule } from "@angular/core";
import { SharedDataAccessStoreModule } from "@kno2/data-access/+store";

@NgModule({
    imports: [SharedDataAccessStoreModule]
})
export class StoreModuleConfiguration {}
